// import React, { useState, useEffect } from "react";
// import { fetchFolders, fetchImages } from "../../util/galerija";

// const GalleryPage = () => {
//   const [albums, setAlbums] = useState([]);
//   const [selectedAlbum, setSelectedAlbum] = useState(null);
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchAlbums = async () => {
//     try {
//       const _albums = await fetchFolders("1CkZ7u_tViLixmtu-hAVjhFwkB-04oq9U");
//       // const response = await fetchImages("1BdUGcu5K5psm9fnxUCUKCZmJwymTyvEs");
//       // setImages(response);
//       setAlbums(_albums);
//     } catch (error) {
//       alert("Napaka pri pridobivanju albumov:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAlbumSelect = async (album) => {
//     setLoading(true);
//     try {
//       setSelectedAlbum(album);
//       const _images = await fetchImages(album.id);
//       setImages(_images);
//     } catch (error) {
//       setSelectedAlbum(null);
//       alert("Napaka pri pridobivanju slik albuma:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Naloži seznam albumov
//   useEffect(() => {
//     fetchAlbums();
//   }, []);

//   const AlbumList = () => {
//     return (
//       <div>
//         {albums.length === 0 ? (
//           <p>Ni najdenih albumov.</p>
//         ) : (
//           albums.map((album) => (
//             <h3
//               key={album.id}
//               style={{
//                 cursor: "pointer",
//                 color: "blue",
//                 marginBottom: "10px",
//               }}
//               onClick={() => handleAlbumSelect(album)}
//             >
//               {album.name}
//             </h3>
//           ))
//         )}
//       </div>
//     );
//   };

//   const ImageList = () => {
//     return (
//       <div>
//         <button onClick={() => setSelectedAlbum(null)}>
//           ← Nazaj na albume
//         </button>
//         <h3>{selectedAlbum.name}</h3>
//         {images.length === 0 ? (
//           <p>Ni slik v tem albumu.</p>
//         ) : (
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
//             {images.map((img) => (
//               <img
//                 key={img.id}
//                 src={img.url}
//                 alt={img.name}
//                 className="rounded-3 shadow-sm"
//                 style={{objectFit: "contain"}}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   const Spinner = () => {
//     return (
//       <div className="spinner-border text-primary" role="status">
//         <span className="visually-hidden">Loading...</span>
//       </div>
//     );
//   };

//   return (
//     <div className="gallery__area" style={{ padding: "2rem" }}>
//       <h2>Galerije</h2>

//       {loading ? <Spinner /> : !selectedAlbum ? <AlbumList /> : <ImageList />}
//     </div>
//   );
// };

// export default GalleryPage;

//------------------

// import React, { useState, useEffect } from "react";
// import { fetchFolders, fetchImages } from "../../util/galerija";

// const GalleryPage = () => {
//   const [albums, setAlbums] = useState([]);
//   const [selectedAlbum, setSelectedAlbum] = useState(null);
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(null); // za modal

//   useEffect(() => {
//     fetchAlbums();
//     // Event listener za puščice
//     const handleKeyDown = (e) => {
//       if (selectedImageIndex !== null) {
//         if (e.key === "ArrowRight") {
//           setSelectedImageIndex((prev) => (prev + 1) % images.length);
//         } else if (e.key === "ArrowLeft") {
//           setSelectedImageIndex((prev) =>
//             prev === 0 ? images.length - 1 : prev - 1
//           );
//         } else if (e.key === "Escape") {
//           setSelectedImageIndex(null);
//         }
//       }
//     };
//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [selectedImageIndex, images]);

//   const fetchAlbums = async () => {
//     try {
//       const _albums = await fetchFolders("1CkZ7u_tViLixmtu-hAVjhFwkB-04oq9U");
//       setAlbums(_albums);
//     } catch (error) {
//       alert("Napaka pri pridobivanju albumov:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAlbumSelect = async (album) => {
//     setLoading(true);
//     try {
//       setSelectedAlbum(album);
//       const _images = await fetchImages(album.id);
//       setImages(_images);
//     } catch (error) {
//       setSelectedAlbum(null);
//       alert("Napaka pri pridobivanju slik albuma:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const AlbumList = () => (
//     <div>
//       {albums.length === 0 ? (
//         <p>Ni najdenih albumov.</p>
//       ) : (
//         albums.map((album) => (
//           <h3
//             key={album.id}
//             style={{
//               cursor: "pointer",
//               color: "#007bff",
//               marginBottom: "10px",
//             }}
//             onClick={() => handleAlbumSelect(album)}
//           >
//             {album.name}
//           </h3>
//         ))
//       )}
//     </div>
//   );

//   const ImageList = () => (
//     <div>
//       <button onClick={() => setSelectedAlbum(null)} style={{ marginBottom: "1rem" }}>
//         ← Nazaj na albume
//       </button>
//       <h3>{selectedAlbum.name}</h3>
//       {images.length === 0 ? (
//         <p>Ni slik v tem albumu.</p>
//       ) : (
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
//           {images.map((img, index) => (
//             <img
//               key={img.id}
//               src={img.url}
//               alt={img.name}
//               onClick={() => setSelectedImageIndex(index)}
//               className="rounded-3 shadow-sm"
//               style={{
//                 width: "200px",
//                 height: "150px",
//                 objectFit: "cover",
//                 cursor: "pointer",
//                 borderRadius: "10px",
//                 transition: "transform 0.2s",
//               }}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );

//   const Spinner = () => (
//     <div className="spinner-border text-primary" role="status">
//       <span className="visually-hidden">Loading...</span>
//     </div>
//   );

//   const ImageModal = () => {
//     if (selectedImageIndex === null) return null;
//     const image = images[selectedImageIndex];
//     return (
//       <div
//         onClick={() => setSelectedImageIndex(null)}
//         style={{
//           position: "fixed",
//           top: 0, left: 0, right: 0, bottom: 0,
//           backgroundColor: "rgba(0,0,0,0.8)",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           zIndex: 1000,
//         }}
//       >
//         <img
//           src={image.url}
//           alt={image.name}
//           style={{
//             maxWidth: "90%",
//             maxHeight: "90%",
//             borderRadius: "8px",
//             boxShadow: "0 0 20px rgba(255,255,255,0.2)",
//           }}
//         />
//       </div>
//     );
//   };

//   return (
//     <div className="gallery__area" style={{ padding: "2rem" }}>
//       <h2 style={{ marginBottom: "1.5rem" }}>Galerije</h2>
//       {loading ? <Spinner /> : !selectedAlbum ? <AlbumList /> : <ImageList />}
//       <ImageModal />
//     </div>
//   );
// };

// export default GalleryPage;

//-----------------------------------------------

// import React, { useState, useEffect } from "react";
// import { fetchFolders, fetchImages } from "../../util/galerija";

// const GalleryPage = () => {
//   const [albums, setAlbums] = useState([]);
//   const [selectedAlbum, setSelectedAlbum] = useState(null);
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(null); // za modal

//   useEffect(() => {
//     fetchAlbums();
//     // Event listener za puščice
//     const handleKeyDown = (e) => {
//       if (selectedImageIndex !== null) {
//         if (e.key === "ArrowRight") {
//           setSelectedImageIndex((prev) => (prev + 1) % images.length);
//         } else if (e.key === "ArrowLeft") {
//           setSelectedImageIndex((prev) =>
//             prev === 0 ? images.length - 1 : prev - 1
//           );
//         } else if (e.key === "Escape") {
//           setSelectedImageIndex(null);
//         }
//       }
//     };
//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [selectedImageIndex, images]);

//   const fetchAlbums = async () => {
//     try {
//       const _albums = await fetchFolders("1CkZ7u_tViLixmtu-hAVjhFwkB-04oq9U");
//       setAlbums(_albums);
//     } catch (error) {
//       alert("Napaka pri pridobivanju albumov:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAlbumSelect = async (album) => {
//     setLoading(true);
//     try {
//       setSelectedAlbum(album);
//       const _images = await fetchImages(album.id);
//       setImages(_images);
//     } catch (error) {
//       setSelectedAlbum(null);
//       alert("Napaka pri pridobivanju slik albuma:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const navigateImages = (direction) => {
//     if (direction === "next") {
//       setSelectedImageIndex((prev) => (prev + 1) % images.length);
//     } else {
//       setSelectedImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//     }
//   };

//   const AlbumList = () => (
//     <div>
//       {albums.length === 0 ? (
//         <p>Ni najdenih albumov.</p>
//       ) : (
//         albums.map((album) => (
//           <h3
//             key={album.id}
//             style={{
//               cursor: "pointer",
//               color: "#007bff",
//               marginBottom: "10px",
//             }}
//             onClick={() => handleAlbumSelect(album)}
//           >
//             {album.name}
//           </h3>
//         ))
//       )}
//     </div>
//   );

//   const ImageList = () => (
//     <div>
//       <button onClick={() => setSelectedAlbum(null)} style={{ marginBottom: "1rem" }}>
//         ← Nazaj na albume
//       </button>
//       <h3>{selectedAlbum.name}</h3>
//       {images.length === 0 ? (
//         <p>Ni slik v tem albumu.</p>
//       ) : (
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
//           {images.map((img, index) => (
//             <img
//               key={img.id}
//               src={img.url}
//               alt={img.name}
//               onClick={() => setSelectedImageIndex(index)}
//               className="rounded-3 shadow-sm"
//               style={{
//                 width: "200px",
//                 height: "150px",
//                 objectFit: "cover",
//                 cursor: "pointer",
//                 borderRadius: "10px",
//                 transition: "transform 0.2s",
//               }}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );

//   const Spinner = () => (
//     <div className="spinner-border text-primary" role="status">
//       <span className="visually-hidden">Loading...</span>
//     </div>
//   );

//   const ImageModal = () => {
//     if (selectedImageIndex === null) return null;
//     const image = images[selectedImageIndex];
    
//     return (
//       <div
//         style={{
//           position: "fixed",
//           top: 0, left: 0, right: 0, bottom: 0,
//           backgroundColor: "rgba(0,0,0,0.9)",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           zIndex: 1000,
//         }}
//         onClick={(e) => {
//           // Zapri modal samo če kliknemo na ozadje, ne na sliko ali gumbe
//           if (e.target === e.currentTarget) {
//             setSelectedImageIndex(null);
//           }
//         }}
//       >
//         {/* Navigacijski gumb levo */}
//         <div
//           style={{
//             position: "absolute",
//             left: "20px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             color: "white",
//             fontSize: "2rem",
//             cursor: "pointer",
//             background: "rgba(0,0,0,0.5)",
//             width: "50px",
//             height: "50px",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             userSelect: "none",
//             zIndex: 1001,
//           }}
//           onClick={(e) => {
//             e.stopPropagation();
//             navigateImages("prev");
//           }}
//         >
//           &#10094;
//         </div>
        
//         {/* Slika - povečana */}
//         <img
//           src={image.url}
//           alt={image.name}
//           style={{
//             maxWidth: "80%",
//             maxHeight: "85%",
//             borderRadius: "8px",
//             boxShadow: "0 0 20px rgba(255,255,255,0.2)",
//             objectFit: "contain",
//           }}
//           onClick={(e) => e.stopPropagation()}
//         />
        
//         {/* Navigacijski gumb desno */}
//         <div
//           style={{
//             position: "absolute",
//             right: "20px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             color: "white",
//             fontSize: "2rem",
//             cursor: "pointer",
//             background: "rgba(0,0,0,0.5)",
//             width: "50px",
//             height: "50px",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             userSelect: "none",
//             zIndex: 1001,
//           }}
//           onClick={(e) => {
//             e.stopPropagation();
//             navigateImages("next");
//           }}
//         >
//           &#10095;
//         </div>
        
//         {/* Zapiralni gumb */}
//         <div
//           style={{
//             position: "absolute",
//             right: "20px",
//             top: "20px",
//             color: "white",
//             fontSize: "2rem",
//             cursor: "pointer",
//             background: "rgba(0,0,0,0.5)",
//             width: "40px",
//             height: "40px",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             userSelect: "none",
//           }}
//           onClick={() => setSelectedImageIndex(null)}
//         >
//           &times;
//         </div>
        
//         {/* Prikaz števila slik */}
//         <div
//           style={{
//             position: "absolute",
//             bottom: "20px",
//             color: "white",
//             padding: "5px 10px",
//             background: "rgba(0,0,0,0.5)",
//             borderRadius: "15px",
//             fontSize: "0.9rem",
//           }}
//         >
//           {selectedImageIndex + 1} / {images.length}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="gallery__area" style={{ padding: "2rem" }}>
//       <h2 style={{ marginBottom: "1.5rem" }}>Galerije</h2>
//       {loading ? <Spinner /> : !selectedAlbum ? <AlbumList /> : <ImageList />}
//       <ImageModal />
//     </div>
//   );
// };

// export default GalleryPage;

//---------------------------------

// import React, { useState, useEffect } from "react";
// import { fetchFolders, fetchImages } from "../../util/galerija";

// const GalleryPage = () => {
//   const [albums, setAlbums] = useState([]);
//   const [selectedAlbum, setSelectedAlbum] = useState(null);
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(null); // za modal

//   useEffect(() => {
//     fetchAlbums();
//     // Event listener za puščice
//     const handleKeyDown = (e) => {
//       if (selectedImageIndex !== null) {
//         if (e.key === "ArrowRight") {
//           setSelectedImageIndex((prev) => (prev + 1) % images.length);
//         } else if (e.key === "ArrowLeft") {
//           setSelectedImageIndex((prev) =>
//             prev === 0 ? images.length - 1 : prev - 1
//           );
//         } else if (e.key === "Escape") {
//           setSelectedImageIndex(null);
//         }
//       }
//     };
//     window.addEventListener("keydown", handleKeyDown);
//     const header = document.querySelector("header");
//     if (selectedImageIndex!=null) {
//       header.style.visibility = "hidden";
//       // if (header) header.style.position = "static";
//     } else {
//       header.style.visibility = "visible";
//       // if (header) header.style.position = "fixed";
//     }
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [selectedImageIndex, images]);

//   const fetchAlbums = async () => {
//     try {
//       const _albums = await fetchFolders("1CkZ7u_tViLixmtu-hAVjhFwkB-04oq9U");
//       setAlbums(_albums);
//     } catch (error) {
//       alert("Napaka pri pridobivanju albumov:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAlbumSelect = async (album) => {
//     setLoading(true);
//     try {
//       setSelectedAlbum(album);
//       const _images = await fetchImages(album.id);
//       setImages(_images);
//     } catch (error) {
//       setSelectedAlbum(null);
//       alert("Napaka pri pridobivanju slik albuma:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const navigateImages = (direction) => {
//     if (direction === "next") {
//       setSelectedImageIndex((prev) => (prev + 1) % images.length);
//     } else {
//       setSelectedImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//     }
//   };

//   const AlbumList = () => (
//     <div>
//       {albums.length === 0 ? (
//         <p>Ni najdenih albumov.</p>
//       ) : (
//         albums.map((album) => (
//           <h3
//             key={album.id}
//             style={{
//               cursor: "pointer",
//               color: "#007bff",
//               marginBottom: "10px",
//             }}
//             onClick={() => handleAlbumSelect(album)}
//           >
//             {album.name}
//           </h3>
//         ))
//       )}
//     </div>
//   );

//   const ImageList = () => (
//     <div>
//       <button onClick={() => setSelectedAlbum(null)} style={{ marginBottom: "1rem" }}>
//         ← Nazaj na albume
//       </button>
//       <h3>{selectedAlbum.name}</h3>
//       {images.length === 0 ? (
//         <p>Ni slik v tem albumu.</p>
//       ) : (
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
//           {images.map((img, index) => (
//             <img
//               key={img.id}
//               src={img.url}
//               alt={img.name}
//               onClick={() => setSelectedImageIndex(index)}
//               className="rounded-3 shadow-sm"
//               style={{
//                 width: "200px",
//                 height: "150px",
//                 objectFit: "cover",
//                 cursor: "pointer",
//                 borderRadius: "10px",
//                 transition: "transform 0.2s",
//               }}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );

//   const Spinner = () => (
//     <div className="spinner-border text-primary" role="status">
//       <span className="visually-hidden">Loading...</span>
//     </div>
//   );

//   const ImageModal = () => {
//     if (selectedImageIndex === null) return null;
//     const image = images[selectedImageIndex];
    
//     return (
//       <div
//         style={{
//           position: "fixed",
//           top: 0, left: 0, right: 0, bottom: 0,
//           backgroundColor: "rgba(0,0,0,0.95)",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           zIndex: 1000,
//         }}
//         onClick={(e) => {
//           // Zapri modal samo če kliknemo na ozadje, ne na sliko ali gumbe
//           if (e.target === e.currentTarget) {
//             setSelectedImageIndex(null);
//           }
//         }}
//       >
//         {/* Navigacijski gumb levo */}
//         <div
//           style={{
//             position: "absolute",
//             left: "10px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             color: "white",
//             fontSize: "2.5rem",
//             cursor: "pointer",
//             background: "rgba(0,0,0,0.5)",
//             width: "50px",
//             height: "50px",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             userSelect: "none",
//             zIndex: 1001,
//           }}
//           onClick={(e) => {
//             e.stopPropagation();
//             navigateImages("prev");
//           }}
//         >
//           &#10094;
//         </div>
        
//         {/* Slika - še bolj povečana */}
//         <img
//           src={image.url}
//           alt={image.name}
//           style={{
//             maxWidth: "95%",
//             maxHeight: "80%",
//             borderRadius: "8px",
//             boxShadow: "0 0 20px rgba(255,255,255,0.2)",
//             objectFit: "contain",
//           }}
//           onClick={(e) => e.stopPropagation()}
//         />
        
//         {/* Navigacijski gumb desno */}
//         <div
//           style={{
//             position: "absolute",
//             right: "10px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             color: "white",
//             fontSize: "2.5rem",
//             cursor: "pointer",
//             background: "rgba(0,0,0,0.5)",
//             width: "50px",
//             height: "50px",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             userSelect: "none",
//             zIndex: 1001,
//           }}
//           onClick={(e) => {
//             e.stopPropagation();
//             navigateImages("next");
//           }}
//         >
//           &#10095;
//         </div>
        
//         {/* Zapiralni gumb */}
//         <div
//           style={{
//             position: "absolute",
//             right: "15px",
//             top: "15px",
//             color: "white",
//             fontSize: "2rem",
//             cursor: "pointer",
//             background: "rgba(0,0,0,0.5)",
//             width: "40px",
//             height: "40px",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             userSelect: "none",
//             zIndex: 1002,
//           }}
//           onClick={() => setSelectedImageIndex(null)}
//         >
//           &times;
//         </div>
        
//         {/* Prikaz števila slik */}
//         <div
//           style={{
//             position: "absolute",
//             bottom: "15px",
//             color: "white",
//             padding: "5px 10px",
//             background: "rgba(0,0,0,0.5)",
//             borderRadius: "15px",
//             fontSize: "0.9rem",
//           }}
//         >
//           {selectedImageIndex + 1} / {images.length}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="gallery__area" style={{ padding: "2rem" }}>
//       <h2 style={{ marginBottom: "1.5rem" }}>Galerije</h2>
//       {loading ? <Spinner /> : !selectedAlbum ? <AlbumList /> : <ImageList />}
//       <ImageModal />
//     </div>
//   );
// };

// export default GalleryPage;

//-------------------------------------------

import React, { useState, useEffect } from "react";
import { fetchFolders, fetchImages } from "../../util/galerija";

const GalleryPage = () => {
  const [albums, setAlbums] = useState([]);
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null); // za modal

  useEffect(() => {
    fetchAlbums();
    // Event listener za puščice
    const handleKeyDown = (e) => {
      if (selectedImageIndex !== null) {
        if (e.key === "ArrowRight") {
          setSelectedImageIndex((prev) => (prev + 1) % images.length);
        } else if (e.key === "ArrowLeft") {
          setSelectedImageIndex((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
          );
        } else if (e.key === "Escape") {
          setSelectedImageIndex(null);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    const header = document.querySelector("header");
    if (selectedImageIndex !== null) {
      header.style.visibility = "hidden";
      // if (header) header.style.position = "static";
    } else {
      header.style.visibility = "visible";
      // if (header) header.style.position = "fixed";
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImageIndex, images]);

  const fetchAlbums = async () => {
    try {
      const _albums = await fetchFolders("1CkZ7u_tViLixmtu-hAVjhFwkB-04oq9U");
      setAlbums(_albums);
    } catch (error) {
      alert("Napaka pri pridobivanju albumov:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAlbumSelect = async (album) => {
    setLoading(true);
    try {
      setSelectedAlbum(album);
      const _images = await fetchImages(album.id);
      setImages(_images);
    } catch (error) {
      setSelectedAlbum(null);
      alert("Napaka pri pridobivanju slik albuma:", error);
    } finally {
      setLoading(false);
    }
  };

  const navigateImages = (direction) => {
    if (direction === "next") {
      setSelectedImageIndex((prev) => (prev + 1) % images.length);
    } else {
      setSelectedImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    }
  };

  const AlbumList = () => (
    <div className="album-container">
      <div className="album-grid">
        {albums.length === 0 ? (
          <p className="no-albums">Ni najdenih albumov.</p>
        ) : (
          albums.map((album) => (
            <div 
              key={album.id} 
              className="album-card"
              onClick={() => handleAlbumSelect(album)}
            >
              <div className="album-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 5V11H14.5C14.2 11 14 11.2 14 11.5V16.5C14 16.8 13.8 17 13.5 17H5V5H19ZM12 14.2L13.5 15.8L15 14.2L16.5 15.8L18 14.2L16.5 12.5L15 14.2L13.5 12.5L12 14.2ZM6.5 12.2L8 13.8L9.5 12.2L11 13.8L12.5 12.2L11 10.5L9.5 12.2L8 10.5L6.5 12.2Z" fill="#3B82F6"/>
                </svg> */}
    
<path d="M17.2905 11.9684C17.2905 12.7071 16.6984 13.3059 15.9679 13.3059C15.2374 13.3059 14.6453 12.7071 14.6453 11.9684C14.6453 11.2297 15.2374 10.6309 15.9679 10.6309C16.6984 10.6309 17.2905 11.2297 17.2905 11.9684Z" fill="#1C274C"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.1316 7.40774C17.2832 7.28707 16.1897 7.28709 14.8267 7.28711H9.17326C7.81031 7.28709 6.7168 7.28707 5.86839 7.40774C4.99062 7.53259 4.25955 7.80048 3.71603 8.42826C3.17252 9.05605 3.00655 9.82426 3.00019 10.7206C2.99404 11.587 3.13858 12.6831 3.31873 14.0493L3.68419 16.8211C3.825 17.8892 3.93897 18.7537 4.11616 19.4306C4.3006 20.1352 4.57289 20.7194 5.08383 21.1718C5.59477 21.6241 6.20337 21.8199 6.91841 21.9116C7.60534 21.9998 8.46777 21.9998 9.53332 21.9998H14.4667C15.5322 21.9998 16.3947 21.9998 17.0816 21.9116C17.7966 21.8199 18.4052 21.6241 18.9162 21.1718C19.4271 20.7194 19.6994 20.1352 19.8838 19.4306C20.061 18.7537 20.175 17.8892 20.3158 16.8211L20.6813 14.0493C20.8614 12.6831 21.006 11.587 20.9998 10.7206C20.9934 9.82426 20.8275 9.05605 20.284 8.42826C19.7404 7.80048 19.0094 7.53259 18.1316 7.40774ZM6.05259 8.73222C5.32568 8.83561 4.95802 9.02418 4.71116 9.30931C4.4643 9.59445 4.32805 9.98791 4.32278 10.7302C4.31738 11.4915 4.44802 12.4942 4.63662 13.9246L4.68663 14.3039L5.05822 14.0318C6.0171 13.3295 7.43388 13.364 8.34576 14.1273L11.7301 16.9601C12.0499 17.2278 12.6011 17.2778 12.9989 17.0438L13.2341 16.9054C14.3594 16.2435 15.8676 16.3133 16.9059 17.0955L18.7378 18.4755C18.8281 17.9799 18.909 17.3707 19.0107 16.5996L19.3634 13.9246C19.552 12.4942 19.6826 11.4915 19.6772 10.7302C19.6719 9.98791 19.5357 9.59445 19.2888 9.30931C19.042 9.02418 18.6743 8.83561 17.9474 8.73222C17.2019 8.62619 16.2018 8.62462 14.7748 8.62462H9.22521C7.79821 8.62462 6.7981 8.62619 6.05259 8.73222Z" fill="#1C274C"/>
<g opacity="0.7">
<path d="M6.87908 4.5C5.62752 4.5 4.60128 5.33974 4.25881 6.45377C4.25167 6.477 4.24482 6.50034 4.23828 6.5238C4.59662 6.40323 4.96954 6.32446 5.34706 6.27068C6.3194 6.13218 7.54821 6.13225 8.97563 6.13234L9.08223 6.13234L15.1785 6.13234C16.606 6.13225 17.8348 6.13218 18.8071 6.27068C19.1846 6.32446 19.5575 6.40323 19.9159 6.5238C19.9093 6.50034 19.9025 6.477 19.8953 6.45377C19.5529 5.33974 18.5266 4.5 17.2751 4.5H6.87908Z" fill="#1C274C"/>
</g>
<g opacity="0.4">
<path d="M8.8585 2.00001H15.1406C15.3498 1.99995 15.5102 1.99991 15.6505 2.01515C16.6475 2.12351 17.4636 2.78957 17.8097 3.68676H6.18945C6.53552 2.78957 7.35159 2.12351 8.34863 2.01515C8.48886 1.99991 8.64927 1.99995 8.8585 2.00001Z" fill="#1C274C"/>
</g>
</svg>
                
              </div>
              <h3 className="album-title">
                {album.name}
              </h3>
            </div>
          ))
        )}
      </div>
    </div>
  );

  const ImageList = () => (
    <div className="image-list-container">
      <button className="back-button" onClick={() => setSelectedAlbum(null)}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="currentColor"/>
        </svg>
        Nazaj na albume
      </button>
      <h3 className="album-header">{selectedAlbum.name}</h3>
      {images.length === 0 ? (
        <p className="no-images">Ni slik v tem albumu.</p>
      ) : (
        <div className="image-grid">
          {images.map((img, index) => (
            <img
              key={img.id}
              src={img.url}
              alt={img.name}
              onClick={() => setSelectedImageIndex(index)}
              className="gallery-image"
              loading="lazy"
            />
          ))}
        </div>
      )}
    </div>
  );

  const Spinner = () => (
    <div className="spinner-wrapper">
      <div className="spinner">
        <div className="spinner-circle"></div>
      </div>
    </div>
  );

  const ImageModal = () => {
    if (selectedImageIndex === null) return null;
    const image = images[selectedImageIndex];
    
    return (
      <div
        className="image-modal"
        onClick={(e) => {
          // Zapri modal samo če kliknemo na ozadje, ne na sliko ali gumbe
          if (e.target === e.currentTarget) {
            setSelectedImageIndex(null);
          }
        }}
      >
        {/* Navigacijski gumb levo */}
        <div
          className="nav-button nav-left"
          onClick={(e) => {
            e.stopPropagation();
            navigateImages("prev");
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="white"/>
          </svg>
        </div>
        
        {/* Slika */}
        <img
          src={image.url}
          alt={image.name}
          className="modal-image"
          onClick={(e) => e.stopPropagation()}
        />
        
        {/* Navigacijski gumb desno */}
        <div
          className="nav-button nav-right"
          onClick={(e) => {
            e.stopPropagation();
            navigateImages("next");
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z" fill="white"/>
          </svg>
        </div>
        
        {/* Zapiralni gumb */}
        <div
          className="close-button"
          onClick={() => setSelectedImageIndex(null)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="white"/>
          </svg>
        </div>
        
        {/* Prikaz števila slik */}
        <div className="image-counter">
          {selectedImageIndex + 1} / {images.length}
        </div>
      </div>
    );
  };

  return (
    <div className="gallery-container">
      <style jsx>{`
        .gallery-container {
          padding: 2rem;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        h2.gallery-title {
          font-size: 2.5rem;
          text-align: center;
          margin-bottom: 2rem;
          color: #1F2937;
          font-weight: 700;
          position: relative;
          padding-bottom: 1rem;
        }
        
        h2.gallery-title:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #3B82F6, #4F46E5);
          border-radius: 2px;
        }
        
        .album-container {
          margin-top: 2rem;
        }
        
        .album-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
        }
        
        .album-card {
          background: #F9FAFB;
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
        
        .album-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        }
        
        .album-icon {
          background: #EFF6FF;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 15px;
        }
        
        .album-title {
          font-size: 1.1rem;
          font-weight: 600;
          color: #1F2937;
          margin: 0;
        }
        
        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: #EFF6FF;
          color: #3B82F6;
          border: none;
          padding: 8px 16px;
          border-radius: 8px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          margin-bottom: 1.5rem;
        }
        
        .back-button:hover {
          background: #DBEAFE;
        }
        
        .album-header {
          font-size: 1.5rem;
          color: #1F2937;
          margin-bottom: 1.5rem;
          font-weight: 600;
        }
        
        .image-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 15px;
        }
        
        .gallery-image {
          width: 100%;
          height: 150px;
          object-fit: cover;
          cursor: pointer;
          border-radius: 10px;
          transition: transform 0.3s ease;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .gallery-image:hover {
          transform: scale(1.05);
        }
        
        .spinner-wrapper {
          display: flex;
          justify-content: center;
          padding: 3rem 0;
        }
        
        .spinner {
          width: 40px;
          height: 40px;
          position: relative;
        }
        
        .spinner-circle {
          width: 100%;
          height: 100%;
          border: 4px solid #DBEAFE;
          border-top-color: #3B82F6;
          border-radius: 50%;
          animation: spinner 0.8s linear infinite;
        }
        
        @keyframes spinner {
          to {
            transform: rotate(360deg);
          }
        }
        
        .image-modal {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.95);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        
        .modal-image {
          max-width: 95%;
          max-height: 90%;
          border-radius: 8px;
          box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
          object-fit: contain;
        }
        
        .nav-button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0, 0, 0, 0.5);
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: background 0.2s;
          z-index: 10000;
        }
        
        .nav-button:hover {
          background: rgba(59, 130, 246, 0.7);
        }
        
        .nav-left {
          left: 20px;
        }
        
        .nav-right {
          right: 20px;
        }
        
        .close-button {
          position: absolute;
          top: 20px;
          right: 20px;
          background: rgba(0, 0, 0, 0.5);
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: background 0.2s;
          z-index: 10001;
        }
        
        .close-button:hover {
          background: rgba(220, 38, 38, 0.7);
        }
        
        .image-counter {
          position: absolute;
          bottom: 20px;
          color: white;
          padding: 5px 12px;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 15px;
          font-size: 0.9rem;
        }
        
        .no-albums, .no-images {
          text-align: center;
          color: #6B7280;
          padding: 2rem;
        }
      `}</style>
      <div className="about__area about__area_one p-relative pb---10">
        <div className="container">
          <div className="col-lg-12">
            <div className="about__content">
              <h2 className="about__title wow animate__fadeInUp" data-wow-duration="0.3s">
                Galerija<br />
              </h2>
            </div>
          </div>
        </div>
      </div>
      {loading ? <Spinner /> : !selectedAlbum ? <AlbumList /> : <ImageList />}
      <ImageModal />
    </div>
  );
};

export default GalleryPage;
